export default __webpack_public_path__ + "static/media/a4h1.d153cf6f.png";